import {EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class LocationData extends EntityData<LocationData> {
    @identifier outletGroupId: number;
    @field groupName: string;
    @field description: string;
    @field exportCode: string;
    @field exportGroupCode: string;
    @field resdiary_restaurantId: number;
    @field resdiary_secondSecret: string;
    @field resdiary_default_dining_time: number = 180;
    @field openTableRestaurantId: string;
    @field yelloStoreId: string;
    @field yelloCheckEta: boolean;
    @field givexStoreId: string;
    @field givexPassword: string;
    @field doorDashEnabled: boolean;
    @field doorDashBusinessName: string;
    @field tyroConnectLocationId: string;
    @field tyroConnectRefreshToken: string;
}

export class LocationReferenceData extends EntityData<LocationReferenceData> {
    @identifier outletGroupId: number;
    @field groupName: string;
}

export class LocationSearchData extends EntityData<LocationSearchData> {
    @identifier outletGroupId: number;
    @field groupName: string;
    @field description: string;
}
